import React, { useEffect, useState } from "react";
import {
  CustomDeleteAPI,
  CustomGetAPI,
  CustomPostAPI,
} from "../Utils/APIConnector";
import { Card } from "react-bootstrap";
import { convertTo12HourFormat, VenueDate } from "../Utils/common";
import { useNavigate } from "react-router-dom";
import Loader from "../Utils/Loader";
import Swal from "sweetalert2";

export default function CouponPage() {
  const [couponData, setCouponData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const loggedin = localStorage.getItem("loggedin");
  const userid = localStorage.getItem("userid");
  const UserType = localStorage.getItem("UserType");
  const navigate = useNavigate();
  useEffect(() => {
    if (
      loggedin &&
      (UserType == "Hybrid" || UserType == "Admin" || UserType == "Venueowner")
    ) {
      CustomGetAPI(`/venue/GetOffers/${userid ?? 0}/false`).then((result) => {
        if (result) {
          result = JSON.parse(result);
          setCouponData(result?.data);
          setIsLoading(false);
        }
      });
    } else {
      navigate("/home");
    }
    setIsLoading(true);
  }, []);

  const deleteCoupon = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Delete Coupon",
      text: "Are you sure you want to delete this coupon?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        CustomDeleteAPI(`/venue/Deleteoffer/${id}`).then((result) => {
          if (result) {
            result = JSON.parse(result);
            setIsLoading(false);
            Swal.fire({
              icon: "success",
              title: "Congratulations!",
              text: "Coupon Deleted Successfully",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/coupon-home";
              }
            });
          }
        });
      } else {
        Swal.close();
      }
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-1">
              <img
                src="/images/backArrow.svg"
                onClick={() => {
                  window.location.href = "/home-venue-owner";
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className="col-11 text-end">
              <button
                className="VenueOwnerBookOfflineBtn  py-2 px-2 float-end Montserrat fw-500"
                style={{ color: "#000000CC" }}
                onClick={() => {
                  window.location.href = "/add-coupon";
                }}
              >
                <img src="/images/plus-circle.svg" alt="" /> Add Coupon
              </button>
            </div>
          </div>
          <div className="row mt-5">
            {couponData && couponData.length > 0 ? (
              couponData?.map((coupon) => (
                <div className="col-md-6 pb-4">
                  <Card>
                    <Card.Header className="couponHeader">
                      <div className="row">
                        <div className="col-10">
                          <b className="signuppolicy">
                            {coupon.code}{" "}
                            {coupon?.sportNames?.length == 1 &&
                              `(${coupon?.sportNames})`}
                          </b>
                        </div>
                        <div className="col-1 px-1 px-md-0">
                          <img
                            src="/images/deleteIcon.svg"
                            alt=""
                            className="img-fluid w-100 cursor-pointer"
                            onClick={() => {
                              deleteCoupon(coupon.id);
                            }}
                          />
                        </div>
                        <div className=" col-1 px-1 px-md-0">
                          <img
                            src="/images/EditNewIcon.svg"
                            className="editImage img-fluid cursor-pointer"
                            alt="edit"
                            onClick={() =>
                              Swal.fire({
                                icon: "warning",
                                title: "Edit Coupon",
                                text: "Are you sure you want to Edit this coupon?",
                                showCancelButton: true,
                                confirmButtonText: "Yes",
                                cancelButtonText: "No",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  navigate("/edit-coupon", {
                                    state: { couponId: coupon.id },
                                  });
                                } else {
                                  Swal.close();
                                }
                              })
                            }
                          />
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <div className="row couponBody">
                        <div className="col-6">
                          <b>Start Date</b>
                          <br />
                          <span>
                            {" "}
                            {VenueDate(coupon.createdDate).formattedDate}
                          </span>{" "}
                        </div>
                        <div className="col-6">
                          <b>End Date</b>
                          <br />
                          <span> {VenueDate(coupon.expiry).formattedDate}</span>
                        </div>
                        <div className="col-6 mt-2">
                          <b>Start Time</b>
                          <br />
                          <span>
                            {" "}
                            {convertTo12HourFormat(coupon.offerStartTime)}
                          </span>
                        </div>
                        <div className="col-6 mt-2">
                          <b>End Time</b>
                          <br />
                          <span>
                            {" "}
                            {convertTo12HourFormat(coupon.offerEndTime)}
                          </span>
                        </div>
                        <div className="col-6 mt-2">
                          <b>Week Days</b>
                          <br />
                          <span> {coupon.weekDays}</span>
                        </div>
                        <div className="col-6 mt-2">
                          <b>Min Duration</b>
                          <br />
                          <span> {coupon.duration} hrs</span>
                        </div>
                        <div className="col-6 mt-2">
                          <b>
                            {coupon.couponTypeId === 1 ? "Flat " : "Max "}Amount
                          </b>
                          <br />
                          <span> {coupon.amountLimit}₹</span>
                        </div>
                        {coupon.offpercentage > 0 && (
                          <div className="col-6 mt-2">
                            <b>Discount %</b>
                            <br />
                            <span> {coupon.offpercentage}%</span>
                          </div>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))
            ) : (
              <div className="text-center fw-600">No Coupon Found</div>
            )}
          </div>
        </>
      )}
    </React.Fragment>
  );
}
